import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../utils/propUtils';
import VeltCommentDialogOptionsDropdownContentDeleteCommentWireframe from './VeltCommentDialogOptionsDropdownContentDeleteCommentWireframe/VeltCommentDialogOptionsDropdownContentDeleteCommentWireframe';
import VeltCommentDialogOptionsDropdownContentDeleteThreadWireframe from './VeltCommentDialogOptionsDropdownContentDeleteThreadWireframe/VeltCommentDialogOptionsDropdownContentDeleteThreadWireframe';
;
var VeltCommentDialogOptionsDropdownContentDeleteWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-options-dropdown-content-delete-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogOptionsDropdownContentDeleteWireframe.Comment = VeltCommentDialogOptionsDropdownContentDeleteCommentWireframe;
VeltCommentDialogOptionsDropdownContentDeleteWireframe.Thread = VeltCommentDialogOptionsDropdownContentDeleteThreadWireframe;
export default VeltCommentDialogOptionsDropdownContentDeleteWireframe;
